module.exports = __webpack_public_path__ + "static/media/image_82.11f434b4.png";